/**
 * Bounded list — a fixed-capacity buffer that keeps the most recent items.
 *
 * Diagnostics collect unbounded streams (queries, reports, slow queries) for
 * inspection, so every collection point owns a capacity instead of passing a
 * limit into each push.
 */

export interface BoundedList<T> {
  clear(): void;
  push(item: T): void;
  /** Copy of the retained items, oldest first. */
  snapshot(): readonly T[];
}

export function createBoundedList<T>(capacity: number): BoundedList<T> {
  const retained = Math.max(1, capacity);
  const items: T[] = [];

  return {
    clear() {
      items.length = 0;
    },

    push(item) {
      items.push(item);
      if (items.length > retained) {
        items.splice(0, items.length - retained);
      }
    },

    snapshot() {
      return [...items];
    },
  };
}
